import type { ResultOf } from "graphql-mock"
import { graphql } from "../../graphql"

export type Journey = ResultOf<typeof journeyFragment>
export type JourneyFolder = ResultOf<
  typeof query
>["journeyFolders"]["nodes"][number]

const journeyFragment = graphql(`
  fragment YourJourneysListJourney on ProductCategory {
    id
    title
    position
    backgroundImageUrl
    teaserImageUrl
    isLocked
    progress: journeyProgress {
      certified
    }
  }
`)

// Folders and the journeys outside them share one position sequence
export const query = graphql(
  `
    query YourJourneysList($limit: Int!, $page: Int) {
      journeyFolders(limit: $limit, page: $page) {
        nodes {
          id
          title
          position
          journeys(limit: $limit, page: $page) {
            nodes {
              ...YourJourneysListJourney
            }
          }
        }
      }
      productCategories(
        isJourney: true
        inJourneyFolder: false
        limit: $limit
        page: $page
      ) {
        nodes {
          ...YourJourneysListJourney
        }
      }
    }
  `,
  [journeyFragment]
)
